import React from 'react'

import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import logger from '@cash-web/shared/util-logger'

import GbFlag from '../../../assets/images/region/GbFlag'
import IeFlag from '../../../assets/images/region/IeFlag'
import UsFlag from '../../../assets/images/region/UsFlag'

type Props = {
  countryCode: `${Country}`
  className?: string
}

export function Flag({ countryCode, className }: Props): React.ReactElement | null {
  switch (countryCode) {
    case Country.US:
      return <UsFlag className={className} />
    case Country.GB:
      return <GbFlag className={className} />
    case Country.IE:
      return <IeFlag className={className} />
    default:
      logger.error(new Error(`Missing flag svg for country code: "${countryCode}"`))
      return null
  }
}
